import { Portal } from '@surveycake/rc';
import { cx } from 'emotion';
import React, { FC, useEffect } from 'react';
import { useStyles } from './styles';

export interface ModalProps {
  className?: string;
  onOpen?: () => void;
  onClose?: () => void;
}

/**
 * A simple Modal component w/o animation.
 * Since w/o implementation of animation it can be rendered only on opened.
 * So it doesn't provide `open` prop.
 */
const Modal: FC<ModalProps> = ({ children, className, onOpen, onClose }) => {
  const styles = useStyles();

  useEffect(() => {
    if (onOpen) {
      onOpen();
    }

    return () => {
      if (onClose) {
        onClose();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Portal>
      <div className={styles.overlay}>
        <div className={cx(styles.modal, className)}>{children}</div>
      </div>
    </Portal>
  );
};

export default Modal;
